<template>
  <el-dialog
    width="788px"
    :visible.sync="modelValue"
    title="上传照片至照片集"
    custom-class="relic-detail-census-uploading"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="uploading-header">
      <!-- <el-button>图片上传</el-button> -->
      <span>{{ `已保存${saveNumber}/${uploadingFileList.length}张照片` }}</span>
    </div>
    <div class="uploading-edit">
      <swiper
        class="uploading-edit-swiper swiper swiper-no-swiping"
        :options="swiperOption"
        ref="imgSwiper"
      >
        <swiper-slide v-for="file in fileList" :key="file.fileId">
          <div class="edit">
            <div class="edit-img">
              <img class="edit-img_photo" :src="file.src" />
              <div class="edit-img_control">
                <!-- <el-checkbox-group v-model="file.visibleMap"> -->
                <el-checkbox
                  label="在地图上显示"
                  v-model="file.visibleMap"
                ></el-checkbox>
                <!-- </el-checkbox-group> -->
                <span @click="handleDeletefile(file.fileId)">删除</span>
              </div>
            </div>
            <div class="edit-base">
              <edit-input-vue
                v-model="info.value"
                v-for="(info, index) in file.baseOption"
                :key="index"
                :label="info.label"
                :placeholder="info.placeholder"
                :edit="file.visibleEdit"
                :options="info.options"
              />
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="uploading-show">
      <swiper class="uploading-show-thumbnail">
        <swiper-slide v-for="file in fileList" :key="file.fileId"
          ><img :src="file.src" class="thumbnail-item" />
        </swiper-slide>
      </swiper>
    </div>
    <div class="uploading-confrim">
      <el-button @click="handleCancel" class="cancel">取消</el-button>
      <el-button @click="handleSubmitImg" class="confrim">提交全部</el-button>
    </div>
    <template v-slot:footer>
      <el-button
        type="text"
        class="swiper-action swiper-prev-btn"
        icon="el-icon-arrow-left"
      ></el-button>
      <el-button
        type="text"
        class="swiper-action swiper-next-btn"
        icon="el-icon-arrow-right"
      ></el-button>
    </template>
    <file-uploader-ctrl-vue
      :filePath="filePath"
      @onUploadSuccess="handleUploadSuccess"
      ref="imgUploader"
      :onlyUpload="true"
    />
  </el-dialog>
</template>

<script>
import { modelMixin } from '../../assets/js/mixins/model';
import OSS from 'ali-oss';
import 'swiper/swiper-bundle.css';
// 按需引入swiper，及其函数
import { Swiper as SwiperClass, Navigation, Thumbs } from 'swiper/core';

import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
import editInputVue from '../layout/edit-input.vue';
import { addRelicPhoto, addRelicDrawing } from '../../api';
import { mapGetters } from 'vuex';
SwiperClass.use([Navigation, Thumbs]);
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
import fileUploaderCtrlVue from '../layout/file-uploader-ctrl.vue';
export default {
  name: 'RelicDetailCensusUploading',
  mixins: [modelMixin],
  components: {
    Swiper,
    SwiperSlide,
    editInputVue,
    fileUploaderCtrlVue
  },
  props: {
    uploadingFileList: {
      type: Array,
      required: true
    },
    imgType: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('relic', ['gettersRelicDetail']),
    fileList() {
      return this.uploadingFileList;
    },
    swiper() {
      return this.$refs.imgSwiper;
    },
    filePath() {
      return `relic/${this.gettersRelicDetail.relicAutoIncrementId}/img`;
    }
  },
  watch: {
    loadedImgNumber() {
      if (this.loadedImgNumber == this.uploadingFileList.length) {
        this.$prompt('提交成功');
        this.$emit('onSuccessUploadingImgs', this.imgType);
        this.modelValue = false;
      }
    }
  },
  data() {
    return {
      saveNumber: 0,
      client: null,
      loadedImgNumber: 0,
      swiperOption: {
        observer: true,
        observerParent: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          prevEl: '.swiper-prev-btn',
          nextEl: '.swiper-next-btn'
        },
        thumbs: {
          swiper: {
            el: '.uploading-show-thumbnail',
            observer: true,
            observerParent: true,
            slidesPerView: 6,
            spaceBetween: 10,
            watchSlidesVisibility: true
          },
          autoScrollOffset: 2,
          slideThumbActiveClass: 'thumbnail-active'
        }
      }
    };
  },
  methods: {
    /**
     * 取消上传
     */
    handleCancel() {
      this.$emit('onCancelUploading');
      this.modelValue = false;
    },
    handleClose(done) {
      this.handleCancel();
      done();
    },

    /**
     * 监听上传成功回调
     */
    handleUploadSuccess(url, param) {
      if (this.imgType === 1) {
        this.addRelicPhoto(url, param);
      } else if (this.imgType === 2) {
        this.addRelicDrawing(url, param);
      }
    },

    /**
     * 提交所有图片与信息
     */
    async handleSubmitImg() {
      for (const [index, value] of this.uploadingFileList.entries()) {
        await this.$refs.imgUploader.handleFileChange({
          files: [value.file],
          param: value
        });
        this.saveNumber = index + 1;
      }
    },

    /**
     * 添加图片至数据库
     */
    addRelicPhoto(result, data) {
      let photo = [
        {
          description: data.baseOption[6].value,
          filmId: data.baseOption[2].value,
          photoId: data.baseOption[1].value,
          photoName: data.baseOption[0].value,
          photographer: data.baseOption[3].value,
          shootDirection: data.baseOption[5].value,
          shootTime: data.baseOption[4].value,
          showInMap: data.visibleMap,
          url: result,
          thumb: result
        }
      ];

      addRelicPhoto(this.gettersRelicDetail.relicAutoIncrementId, photo).then(
        res => {
          if (res.data.code == 200) {
            this.loadedImgNumber = this.loadedImgNumber + 1;
          }
        }
      );
    },
    /**删除 */
    handleDeletefile(fileId) {
      let index = this.uploadingFileList.findIndex(e => {
        return e.fileId == fileId;
      });
      this.uploadingFileList.splice(index, 1);
    },
    /**
     * 添加图纸至数据库
     */
    addRelicDrawing(result, data) {
      let draw = [
        {
          createTime: data.baseOption[4].value,
          creator: data.baseOption[3].value,
          drawingId: data.baseOption[1].value,
          drawingName: data.baseOption[0].value,
          // relicAutoIncrementId: this.gettersRelicDetail.relicAutoIncrementId,
          scale: data.baseOption[2].value,
          showInMap: data.visibleMap,
          url: result,
          thumb: result
        }
      ];

      addRelicDrawing(this.gettersRelicDetail.relicAutoIncrementId, draw).then(
        res => {
          if (res.data.code == 200) {
            this.loadedImgNumber = this.loadedImgNumber + 1;
          }
        }
      );
    }
  }
};
</script>

<style lang="scss">
.relic-detail-census-uploading {
  .el-dialog {
    &__header {
      padding-top: 23px;
      padding-left: 36px;
    }
    &__title {
      font-size: 22px;
      color: #333;
      font-family: 'Arial Negreta';
    }
    &__headerbtn {
      font-size: 35px;
      line-height: 1;
      top: -4px;
      right: -42px;
    }
    &__close {
      color: #fff;
    }
    &__body {
      position: relative;
      padding: 20px 40px;
      z-index: 1;
      max-height: 80vh;
      height: 750px;
      overflow-y: auto;
    }
    &__footer {
      display: flex;
      position: absolute;
      justify-content: space-between;
      padding: 0;
      width: 130%;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
    }
  }
  .swiper-action {
    font-size: 55px;
    font-weight: bold;
    color: #fff;
  }
  .uploading {
    &-confrim {
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
      .el-button {
        width: 71px;
        height: 39px;
      }
      .confrim {
        background-color: $color-primary;
        color: #fff;
      }
      .cancel {
        color: $color-primary;
        border: 1px solid $color-primary;
      }
    }
    &-header {
      .el-button {
        padding: 0px 10px;
        margin-right: 20px;
        background-color: $color-primary;
        color: #fff;
        width: auto;
        height: 40px;
        line-height: 40px;
      }
    }
    &-edit {
      margin-top: 35px;
      &-swiper {
        position: relative;
        .edit {
          width: 100%;
          display: flex;
          background-color: #e2e2e2;
          &-img {
            flex: 1;
            padding: 10px;
            &_photo {
              display: block;
              width: 285px;
              height: 274px;
              background-color: #d2d2d2;
            }
            &_control {
              display: flex;
              justify-content: space-between;
              margin: 10px 0;
              width: 285px;
            }
          }
          &-base {
            flex: 1;
            padding: 10px;
            .edit-input {
              &__content {
                width: 215px;
              }
              &__label {
                position: relative;
                width: 65px;
                text-align-last: justify;
                &::after {
                  content: ':';
                  position: absolute;
                  transform: translateY(-50%);
                  right: -6px;
                  top: 50%;
                }
              }
            }
          }
        }
        .edit-save {
          display: block;
          margin-top: 25px;
          cursor: pointer;
          border-bottom: 1px solid $color-primary;
          color: $color-primary;
        }
        .save-content {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
    &-show {
      &-thumbnail {
        margin-top: 25px;
        padding-top: 35px;
        border-top: 1px solid $color-border-light;
        .swiper-slide {
          width: 100px !important;
          height: 100px;
          margin: 10px;
        }
        .thumbnail-item {
          display: block;
          width: 100px;
          height: 100px;
          background-color: #d2d2d2;
        }
        .thumbnail-active {
          .thumbnail-item {
            border: 2px solid $color-primary;
          }
        }
      }
    }
  }
}
</style>
